<template>
  <div class="accountAuth">
    <el-row :gutter="20">
      <el-col :span='17'>
        <el-table
          :data="tableData"
          height="532"
          ref="singleTable"
          highlight-current-row
          @current-change="handleCurrentChange"
          :cell-class-name="tableRowClassName"
          class="myMemTable"
          style="width: 100%"
          :header-cell-style="{background:'#EFF1F5'}"
        >
          <el-table-column align="center" prop="staffId" label="员工编号"></el-table-column>
          <el-table-column align="center" prop="staffName" label="姓名"></el-table-column>
          <el-table-column align="center" prop="staffPhone" label="手机号"></el-table-column>
          <el-table-column align="center" prop="postId" label="岗位">
            <template slot-scope="scope">
              {{scope.row.postId | filterPostId(infolist.postIdData) | filterRow}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="status" label="状态">
            <template slot-scope="scope">
                {{scope.row.status | filterStatus}}
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span='7'>
        <div class="treeDialog">
          <div class="treeList">
                <el-tree
                  :data="data2"
                  ref="tree"
                  show-checkbox
                  node-key="id"
                  default-expand-all
                  :default-checked-keys="checkedKeys"
                  :props="defaultProps"
                  @check-change="chooseNode"
                  class="checkBoxcom"
                ></el-tree>
              </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="btnOptions">
      <!-- <el-button class="darkBtn" @click="toBack">返回</el-button> -->
      <el-button :class="clickFalg?'redBtn':'greyBtn'" @click="onSubmit" :disabled="!clickFalg">提交</el-button>
    </el-row>
  </div>
</template>
<script>
import {allStaff, selectResource, getByUserIdNoTree, authorize} from '@/api';
import infolist from '@/assets/js/info'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  data() {
    return {
      tableData: [],
      infolist:infolist,
      data2:[],
      defaultProps: {
        children: "children",
        label: "label"
      },
      clickFalg:false,
      curChooseRow:'',//当前选中的数据
      checkedKeys:[]
    };
  },
  created() {
    this.search();
  },
  methods: {
    search(){
      allStaff({
        status:'1'
      }).then(res=>{
        this.tableData = res.data;
        this.tableData.forEach((i,index)=>{
          if(i.staffId == this.$route.params.staffId){
            this.$nextTick(()=>{
              $('.el-table__body').find('.el-table__row').eq(index).addClass('current-row');
            });
            this.handleCurrentChange(i);
            return;
          }
        })
      })
      selectResource().then(res=>{
        // 槑博士，臻幼堂没有上门服务费、员工服务消耗业绩
        for(let i of res.data){  
          // 只有老板有结算权限
          if(i.id == 4 && !this.$store.state.userInfo.storeList){
            for(let m of i.children){
              if(m.id == 38){
                i.children.splice(i.children.indexOf(m),1);
              }
            }
          }
          if(this.$store.state.userInfo.brandId != 1){          
            if(i.id == 4 || i.id == 37){
              for(let m of i.children){
                if(m.id == 18 || m.id == 32){
                  i.children.splice(i.children.indexOf(m),1);
                }
              }
            }
          }
        }
        this.$nextTick(()=>{
          this.data2 = res.data;
          // 默认操作台选中不可选 disabled: true
          for(let m of this.data2){
            if(m.id == 2){
              m.disabled = true
            }
          }
        })
      })
    },
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
        //把每一行的索引放进row
        if (rowIndex % 2 == 1) {
          return "highLight";
        }
        return "";
    },
    handleCurrentChange(val) {
      this.curChooseRow = val;
      getByUserIdNoTree({
        userId:val.staffId
      }).then(res=>{
        let curLimit = [];
        for(let i of res.data){
          if(i != 3 && i != 4){
            curLimit.push(i)
          }
        }
        this.$refs.tree.setCheckedKeys(curLimit);
        this.checkedKeys = curLimit;
      })
    },
    toBack(){
      // 返回
    },
    onSubmit(){
      // 提交  保存之后，用户需退出重登后生效。
      if(this.curChooseRow){
        authorize({
          ids:[this.curChooseRow.staffId],
          resourceIds:this.$refs.tree.getCheckedKeys()
        }).then(res=>{
          this.$message({
            type: res.code == 1 ? "success" : "error",
            message: res.msg
          });
          if(res.code == 1){
            this.$refs.singleTable.setCurrentRow('');
            this.$refs.tree.setCheckedKeys([]);
            this.clickFalg = false;
          }
        })
      }else{
        this.$confirm( '请先选择员工才能设置权限', "提示", {
            distinguishCancelAndClose: true,
            confirmButtonText: '知道了',
            showCancelButton:false,
            type: "warning"
        })
      }
    },
    chooseNode(node){
      if(this.$refs.tree.getCheckedKeys().join(',') == this.checkedKeys.join(',')){
        this.clickFalg = false;
      }else{
        this.clickFalg = true;
      }
      $('.el-tree').children('.el-tree-node').children('.el-tree-node__content').each(function(index,elem){
        if($(elem).children('.el-checkbox').attr('aria-checked')){
          $(elem).addClass('curChecked');
        }else{
          $(elem).removeClass('curChecked');
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.accountAuth {
  padding: 68px 0 0;
  overflow: hidden;
  .myMemTable {
    border: 1px solid #d5d9e3;
  }
  .treeList{
	  min-height: 600px;
    border: 1px solid #C0C5CF;
    padding: 10px 15px 10px 10px;
  }
  .btnOptions{
	text-align: center;
	margin: 45px;
	.el-button {
		width: 110px;
    height: 40px;
    line-height: 40px;
    padding: 0;
    border: none;
    font-size: 14px;
		&.greyBtn{
			background: #c0c5cf;
			color: #fff;
		}
	}
}
}
</style>
<style lang="less">
.myMemTable {
  .operation {
    .cell {
      padding: 0;
    }
  }
  .el-table__header {
    background: rgb(239, 241, 245);
  }
  .highLight {
    background: #eff1f5;
  }
  .el-table__row.current-row{
    td{
      background:#E5E8EF;
      font-weight:bold;
    }
  }
}
.treeDialog{
  max-width:440px;
	height: 100%;
  overflow: hidden;
  margin-top:-35px;
  .checkBoxcom>.el-tree-node>.el-tree-node__content>.el-tree-node__expand-icon{
    &:not(.is-leaf){
      background:url(../../assets/images/store/icon_power_rightarrow.png) no-repeat center;
    }
  }
  .el-tree-node__expand-icon{
    padding:12px 10px 12px 40px;
    &:not(.is-leaf){
      background:url(../../assets/images/store/icon_power_right.png) no-repeat center;
    }
    &::before{
			content:''
		}
  }
	.el-tree-node__label{
		color:#222;
		// font-weight:bold;
		padding-left:10px;
	}
	.el-tree>.el-tree-node>.el-tree-node__content{
		background:#EFF1F5;
		height: 42px;
    margin-bottom:5px;
    >.el-tree-node__label{
      font-weight:bold;
    }
		&.curChecked{
      background:#F83B56;
      .el-tree-node__expand-icon{
        &:not(.is-leaf){
          background:url(../../assets/images/store/icon_power_spread.png) no-repeat center;
        }
      }
		}
	}
	.el-checkbox__input.is-indeterminate .el-checkbox__inner{
		background-color:#F83B56;
		border-color:#F83B56
	}
	.curChecked{
		.el-checkbox__input.is-indeterminate .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner{
			background-color:#fff;
			border-color:#fff;
			&::before{
				background-color:#F83B56
      }
      &::after{
        border:1px solid #F83B56;
        border-left: 0;
        border-top: 0;
			}
		}
		.el-tree-node__label{
			color:#fff
		}
	}
}
</style>





// WEBPACK FOOTER //
// src/components/basicDataCenter/accountAndAuthority.vue